<template>
  <form action="">
    <div class="modal-card" :class="{ 'is-mobile': isMobile }">
      <header class="modal-card-head has-background-success">
        <p class="modal-card-title has-text-white">Terminar venta</p>
        <button type="button" class="delete" @click="$emit('close', 'venta')" />
      </header>
      <section class="modal-card-body">
        <p class="is-size-1 has-text-weight-bold">
          Total ${{ parseInt(totalVenta).toLocaleString("es-CO") }}
        </p>
        <busqueda-cliente-f @seleccionado="onSeleccionado" />
        <b-field label="El cliente paga con">
          <b-input
            step="any"
            ref="Efectivo"
            icon="currency-usd"
            type="number"
            placeholder="Efectivo"
            v-model="efectivo"
            @input="calcularCambio"
            size="is-medium"
          ></b-input>
          <b-input
            step="any"
            ref="nequi"
            icon="bank"
            type="number"
            placeholder="Nequi"
            v-model="nequi"
            @input="calcularCambio"
            size="is-medium"
          ></b-input>
        </b-field>
        <b-field>
          <b-input
            step="any"
            ref="transferencia"
            icon="bank"
            type="number"
            placeholder="Bancolombia"
            v-model="transferencia"
            @input="calcularCambio"
            size="is-medium"
          ></b-input>

          <b-input
            step="any"
            ref="pagadoTarjeta"
            icon="credit-card"
            type="number"
            placeholder="Tarjeta"
            v-model="tarjeta"
            @input="calcularCambio"
            size="is-medium"
          ></b-input>
        </b-field>
        <p class="is-size-1 has-text-weight-bold">
          Cambio {{ cambio.toLocaleString("es-CO") }}
        </p>
      </section>
      <footer class="modal-card-foot">
        <b-button
          label="Cancelar"
          icon-left="cancel"
          size="is-medium"
          @click="$emit('close', 'venta')"
        />
        <b-button
          label="Terminar venta"
          type="is-success"
          icon-left="check"
          size="is-medium"
          @click="terminarVenta"
        />
      </footer>
    </div>
  </form>
</template>
<script>
import BusquedaClienteF from "../Clientes/BusquedaClienteF";
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  name: "DialogoTerminarVenta",
  props: ["totalVenta"],
  components: { BusquedaClienteF },

  data: () => ({
    pagado: "",
    efectivo: "",
    tarjeta: "",
    transferencia: "",
    nequi: "",
    cambio: 0,
    cliente: {},
    processingVenta: false,
    fve: "",
  }),

  async mounted() {
    await this.obtenerDatos(); // Espera a obtener los datos antes de llamar a obtenerVentas
    document.addEventListener("keydown", this.handleKeydown);
    this.$refs.Efectivo.focus();
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    async obtenerDatos() {
      this.cargando = true;
      try {
        const resultado = await HttpService.obtenerConConsultas("ajustes.php", {
          accion: "obtener",
        });
        this.datosNegocio = resultado;
        this.fve = resultado.correo === 1 ? "si" : "no";
      } catch (error) {
        console.error("Error obteniendo datos:", error);
      } finally {
        this.cargando = false;
      }
    },
    formatoMoneda(valor) {
      return valor.toLocaleString("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    handleKeydown(event) {
      if (event.keyCode === 113) {
        // F2
        if (this.fve === "si" && Object.keys(this.cliente).length === 0) {
          Swal.fire({
            icon: "info",
            title: "Información",
            text: "Debe seleccionar un cliente antes de continuar.",
          });
          return;
        }

        if (!this.processingVenta) {
          this.terminarVentaSinF();
          this.processingVenta = true;
        }
      }

      if (event.key === "F3") {
        if (this.fve === "si" && Object.keys(this.cliente).length === 0) {
          Swal.fire({
            icon: "info",
            title: "Información",
            text: "Debe seleccionar un cliente antes de continuar.",
          });
          return;
        }

        event.preventDefault();
        if (!this.processingVenta) {
          this.terminarVenta();
          this.processingVenta = true;
        }
      }
    },

    onSeleccionado(cliente) {
      this.cliente = cliente;
    },

    calcularCambio() {
      const totalPagado =
        parseInt(this.efectivo || 0) +
        parseInt(this.transferencia || 0) +
        parseInt(this.tarjeta || 0) +
        parseFloat(this.nequi || 0);
      this.pagado = totalPagado;
      this.cambio = parseInt(totalPagado - this.totalVenta);
    },

    terminarVenta() {
      // Validar solo si fve es exactamente "si"
      if (this.fve === "si" && Object.keys(this.cliente).length === 0) {
        Swal.fire({
          icon: "info",
          title: "Información",
          text: "Debe seleccionar un cliente antes de continuar.",
        });
        return;
      }

      if (this.pagado === "" || this.pagado < this.totalVenta) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "Debes colocar el total pagado.",
        });
        return;
      }

      let payload = {
        tipo: "venta",
        pagado: this.pagado,
        cambio: parseInt(this.cambio),
        cliente: this.cliente,
        efectivo: parseInt(this.efectivo - this.cambio),
        tarjeta: this.tarjeta,
        transferencia: this.transferencia,
        nequi: parseInt(this.nequi),
      };

      this.$emit("terminar", payload);
      console.log("dialogo llegue");
    },

    terminarVentaSinF() {
      // Validar solo si fve es exactamente "si"
      if (this.fve === "si" && Object.keys(this.cliente).length === 0) {
        Swal.fire({
          icon: "info",
          title: "Información",
          text: "Debe seleccionar un cliente antes de continuar.",
        });
        return;
      }

      if (this.pagado === "" || this.pagado < this.totalVenta) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "Debes colocar el total pagado.",
        });
        console.log(this.pagado);
        return;
      }

      let payload = {
        tipo: "venta",
        pagado: this.pagado,
        cambio: parseInt(this.cambio),
        cliente: this.cliente,
        efectivo: parseInt(this.efectivo - this.cambio),
        tarjeta: this.tarjeta,
        transferencia: this.transferencia,
        nequi: parseInt(this.nequi),
      };

      this.$emit("terminarsinf", payload);
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768; // Ancho típico para móviles
    },
  },
};
</script>
